import { useContext } from 'react'

import { UserContext } from '../contexts/user/UserContext'

export const useUser = () => {
    const context = useContext(UserContext)

    if (!context) {
        throw new Error('useUserContext must be used within a UserProvider')
    }

    return context
}